import { router } from '@inertiajs/vue3';
import { toast } from 'vue-sonner';

export function initializeHttpErrorHandling() {
    router.on('httpException', (event) => {
        const responseBody = event.detail?.response?.data;

        if (!responseBody?.error) {
            return;
        }

        event.preventDefault();

        toast.error(responseBody.error);
    });
}
